<ng-container *ngIf="okService.billing.extend_allow">
    <div class="card mb-2" *transloco="let t">
        <div class="card-header">
          <h3>{{ t('I need more time') }}</h3>
        </div>
        <div class="card-body">
            <p>{{ t('No problem, use this button below to keep trialing the system.') }}</p>


            <button type="button" class="btn btn-warning text-white" (click)="extend()">
              {{ t('Extend your Free Trial ') }}
              <span *ngIf="loading"><i class="fa-solid fa-spinner fa-spin"></i></span>

            </button>

            <div *ngIf="notice" class="alert" [class.alert-warning]="!notice.success"  [class.alert-success]="notice.success"  role="alert">
              {{notice.message}}
            </div>




        </div>
      </div>
</ng-container>
